// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".course-info[data-v-01deaf1e]{align-items:center;display:flex;gap:12px}.course-info .item[data-v-01deaf1e]{align-items:center;color:#868e96;display:flex;gap:2px}.course-info .divider[data-v-01deaf1e]{background-color:#bfc2c5;height:12px;width:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
